module.exports = __webpack_public_path__ + "img/loading.a7f7163c.png";